export enum EIntrosRoutes {
  INTROS = 'Intros',
  INTROS_DETAIL = 'Intro.Detail'
}
